<script setup lang="ts">
/** Shimmering placeholder block for in-screen loading states. */
defineProps<{ width?: string; height?: string; radius?: string }>();
</script>

<template>
  <div class="app-skeleton" :style="{ width, height, borderRadius: radius }" aria-hidden="true" />
</template>

<style lang="scss" scoped>
.app-skeleton {
  width: 100%;
  height: 1rem;
  border-radius: borderRadius('xsmall');
  background-color: theme('color-bg-app-overlay');
  background-image: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.65) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  background-size: 200% 100%;
  background-repeat: no-repeat;
  animation: app-skeleton-shimmer 1.4s ease-in-out infinite;
}

@keyframes app-skeleton-shimmer {
  0% {
    background-position: -150% 0;
  }
  100% {
    background-position: 150% 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .app-skeleton {
    animation: none;
  }
}
</style>
